export default __webpack_public_path__ + "static/media/ic-sm-cultivation-4.54b57d20.svg";